var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlgoliaSearchComponent } from './algolia-search/algolia-search.component';
import { provideAlgoliaService, AlgoliaService } from './algolia.service';
import { HttpClientModule, HttpClient } from '@angular/common/http';
export function httpFactory(http) {
    return new TranslateHttpLoader(http, '/assets/i18n/', '.json?t=' + process.env.VERSION);
}
var AlgoliaModule = (function () {
    function AlgoliaModule() {
    }
    AlgoliaModule_1 = AlgoliaModule;
    AlgoliaModule.conf = function () {
        return {
            ngModule: AlgoliaModule_1,
            providers: [
                { provide: AlgoliaService,
                    useFactory: provideAlgoliaService,
                }
            ]
        };
    };
    AlgoliaModule = AlgoliaModule_1 = __decorate([
        NgModule({
            imports: [
                CommonModule,
                FormsModule,
                HttpClientModule,
                TranslateModule.forRoot({
                    loader: {
                        provide: TranslateLoader,
                        useFactory: httpFactory,
                        deps: [HttpClient]
                    }
                }),
            ],
            declarations: [AlgoliaSearchComponent],
            exports: [AlgoliaSearchComponent]
        })
    ], AlgoliaModule);
    return AlgoliaModule;
    var AlgoliaModule_1;
}());
export { AlgoliaModule };
/*

api_key and search_api_key are defined when the module is imported
index is defined when you use the component.

this allow to import the module once per API you use, and use different index with each component
A service is created when you load the module which connect to the Algolia API, and the servie is shared between components

In your other component, use :
<pt-algolia-search index="your_index_name" [params]="{algolia_api_param:value}">
    <ng-template let-result>
        <div class="row">
            <span class="col-xs-3">{{result.your_first_attribute}}</span>
            <span class="col-xs-9">- {{result.your_second_attribute}}</span>
        </div>
    </ng-template>
</pt-algolia-search>

You can use whatever template you want
You need to install
npm install algoliasearch --save
npm install --save @types/algoliasearch

Import this module directly into the module where you intend to use the component
imports : [...,
AlgoliaModule.conf(),
...]

*/
//# sourceMappingURL=algolia.module.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/algolia/algolia.module.js
// module id = 802
// module chunks = 0